<template>
    <table class="w-100 mt-3 table-border-thick table" style="border-width: 3px;">
        <tbody>
            <tr>
                <td>
                    <h3>{{ $t('report.types.CASHIER_REPORT') }}</h3>
                    <table class="w-100 table-sm table-borderless" v-for="cashier in report.cashiers" :key="cashier.cashier">
                        <tbody>
                            <tr>
                                <th colspan="3">{{ $t('report.cashier') }} {{ cashier.cashier }}</th>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">{{ cashier.operations.sell.count }}</td>
                                <td class="align-top flex-grow-1">{{ $t(`report.sell`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ cashier.operations.sell.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">{{ cashier.operations.buy.count }}</td>
                                <td class="align-top flex-grow-1">{{ $t(`report.buy`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ cashier.operations.buy.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">{{ cashier.operations.sell_return.count }}</td>
                                <td class="align-top flex-grow-1">{{ $t(`report.sellReturn`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ cashier.operations.sell_return.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">{{ cashier.operations.buy_return.count }}</td>
                                <td class="align-top flex-grow-1">{{ $t(`report.buyReturn`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ cashier.operations.buy_return.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: 'CashierReportDetails',
    props: {
        report: Object
    }
}
</script>
